import map from "lodash/fp/map";
import find from "lodash/fp/find";
import first from "lodash/fp/first";
import last from "lodash/fp/last";
import mapValues from "lodash/fp/mapValues";
import each from "lodash/fp/each";
import { toObject, fromMilliseconds } from "../../core/utils";
import constants from "../../core/constants";

class CityPageTransform {
  constructor(Lists) {
    "ngInject";

    this.Lists = Lists.all;
  }

  justify(data) {
    const formatPolicyRules = (rule) => {
      const findAnchor = (a) => a.value === rule.anchor;
      const anchor = find(findAnchor)(
        this.Lists.cancellationRulesAnchorOptions
      );
      const type =
        rule.span <= 0
          ? last(this.Lists.cancellationRulesTimeOptions)
          : first(this.Lists.cancellationRulesTimeOptions);
      const span = Math.abs(rule.span / constants.fromMinToMilli);
      const percent = rule.percent * 100;

      return { anchor, type, span, percent };
    };
    const mapFeatureFlagObject = (featureFlag) => {
      return { ...featureFlag, value: featureFlag.enabled };
    };
    const toNumber = (item) => Number(item);

    const removeId = (item) => {
      delete item._id;
    };

    each(removeId)(data.checking_config);

    if (data.contact) {
      data.contact.emails = toObject(data.contact.emails);
      data.contact.numbers = toObject(map(toNumber)(data.contact.numbers));
      data.contact.hotlines = toObject(map(toNumber)(data.contact.hotlines));
    }
    if (data.feature_flags) {
      data.feature_flags = toObject(
        mapValues(mapFeatureFlagObject)(data.feature_flags)
      );
    }
    data.ride_cancellation_compensation /= constants.currencyBy;

    data.delay_compensation_policy.amount /= constants.currencyBy;
    data.delay_compensation_policy.threshold /= constants.fromMinToMilli;
    data.delay_compensation_policy.expiry /= constants.fromDayToMilli;
    data.transfer_compensation_policy.amount /= constants.currencyBy;
    data.transfer_compensation_policy.expiry /= constants.fromDayToMilli;
    data.station_latency_threshold /= constants.fromMilliToMin;
    data.station_latency_notification_threshold /= constants.fromMilliToMin;

    if (data.book_options) {
      data.book_options = Object.assign(
        data.book_options,
        toObject({
          max_debt: data.book_options.max_debt / constants.currencyBy,
        })
      );
      data.book_options = Object.assign(
        data.book_options,
        toObject({ max_cash_bookings: data.book_options.max_cash_bookings })
      );
    }
    if (data.refer_options) {
      data.refer_options.amount /= constants.currencyBy;
    }
    const defaultPercent = data.cancellation_policy.default_percent;
    const missPercent = data.cancellation_policy.miss_percent;
    data.cancellation_policy.default_percent = defaultPercent
      ? defaultPercent * 100
      : defaultPercent;
    data.cancellation_policy.miss_percent = missPercent
      ? missPercent * 100
      : missPercent;
    data.cancellation_policy.rules = map(formatPolicyRules)(
      data.cancellation_policy.rules
    );
    data.timezone = fromMilliseconds(data.timezone);
    data.refer_options = toObject(data.refer_options);
    return toObject(data);
  }

  formatCancellation(options, name) {
    const policy = {};
    const rules = options[name];
    const formatSpan = (span, type) => constants.fromMinToMilli * span * type;
    const formatRule = (rule) => {
      const span = formatSpan(rule.span, rule.type.value);
      const anchor = rule.anchor.value;
      const percent = rule.percent / 100;

      return { span, anchor, percent };
    };

    policy.rules = [...map(formatRule)(rules)];
    policy.default_percent = options.default_percent / 100;
    policy.miss_percent = options.miss_percent / 100;

    return policy;
  }
}

export default CityPageTransform;



// WEBPACK FOOTER //
// ./src/pages/city/city.transforms.js